import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import type { DpRequestCardProps } from './dpRequestCard.types';

const BASE_CLASS = 'flex h-full flex-col rounded-2xl border border-raro-gray-200 bg-white p-5 shadow-sm';

export function DpRequestCard({ title, description, note, icon: Icon, to, badge }: DpRequestCardProps) {
    const content = (
        <>
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-50 text-primary-600">
                <Icon className="h-6 w-6" aria-hidden="true" />
            </span>

            <div className="mt-4 flex items-start justify-between gap-3">
                <h3 className="font-montserrat text-base font-semibold text-raro-gray-900">{title}</h3>
                {badge && (
                    <span className="shrink-0 rounded-full bg-raro-gray-100 px-2.5 py-0.5 text-xs font-semibold text-raro-gray-600">
                        {badge}
                    </span>
                )}
            </div>

            <p className="mt-1 flex-1 text-sm text-raro-gray-500">{description}</p>

            {note && (
                <div className="mt-4 flex items-start gap-2 border-t border-dashed border-primary-200 pt-3 text-xs text-raro-gray-500">
                    <CalendarDaysIcon className="mt-px h-4 w-4 shrink-0" aria-hidden="true" />
                    <span>{note}</span>
                </div>
            )}
        </>
    );

    if (to) {
        return (
            <Link
                to={to}
                className={clsx(
                    BASE_CLASS,
                    'transition hover:-translate-y-0.5 hover:border-primary-200 hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-500'
                )}
            >
                {content}
            </Link>
        );
    }

    return (
        <div aria-disabled="true" className={clsx(BASE_CLASS, 'opacity-90')}>
            {content}
        </div>
    );
}
